import React, { Component } from "react";
import Nouislider from "nouislider-react";
import wNumb from "wnumb";

/**
 *
 * props
 * filterdata {Object}
 *
 */
class FilterRange extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const filterdata = this.props.filterdata;
    return (
      <div className={'filter-options filterrange-container'}>
        <p className={"filter-options-title"}>{filterdata.title}</p>
        <div className={"customNoUiSlider"}>
          <Nouislider
            range={{ min: filterdata.min_range, max: filterdata.max_range }}
            tooltips={[wNumb({ decimals: 0 }), wNumb({ decimals: 0 })]}
            step={1}
            start={[
              this.props.objectfilter[0],
              this.props.objectfilter[1],
            ]}
            onSlide={(render, handle, value, un, percent) => {
                this.props.onSlide(value, filterdata.key);
            }}
            connect
          />
        </div>
      </div>
    );
  }
}

export default FilterRange;
